import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year5/Summer/Volume/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Volume',
  field: 'Measurement',
  weeks: [12, 12],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Volume/1CubicCentimetres" */ './1CubicCentimetres'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(/* webpackChunkName: "Year5/Summer/Volume/2CompareVolume" */ './2CompareVolume')
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(/* webpackChunkName: "Year5/Summer/Volume/3EstimateVolume" */ './3EstimateVolume')
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Volume/4EstimateCapacity" */ './4EstimateCapacity'
        )
    })
  ]
});
export default Block;
